export interface SnackbarState {
  message: string;
  show: boolean;
  color: string;
}

export enum MutationTypes {
  SET_SHOW = 'SET_SHOW'
}

export enum ActionTypes {
  SHOW = 'SHOW',
  FETCH_ME = 'FETCH_ME'
}

export enum GetterTypes {
  GET_MESSAGE = 'GET_MESSAGE',
  GET_SHOW = 'GET_SHOW',
  GET_COLOR = 'GET_COLOR'
}
